// app/javascript/controllers/checkbox_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trueBox", "falseBox", "falseBoxLabel", "trueBoxLabel"]

  connect() {}

  toggle(event) {
    if (event.target === this.trueBoxTarget || event.target === this.trueBoxLabelTarget) {
      if (this.trueBoxTarget.checked) {
        this.falseBoxTarget.checked = false;
      }
      console.log("falseBoxTarget:" + this.falseBoxTarget.checked);
    } else if (event.target === this.falseBoxTarget || event.target === this.falseBoxLabelTarget) {
      if (this.falseBoxTarget.checked) {
        this.trueBoxTarget.checked = false;
      }
    }
  }
}
